<footer class="footer ">
  <div class="container-fluid">
    <div class="copyright pull-right">
      &copy;
      {{test | date: 'yyyy'}}, made by
      <a href="#" target="_blank">©NECTEC</a>
    </div>
  </div>
</footer>
